import {QuestionMatchingEvaluationResponse} from './AiSupport.types';

const candidateCount = 10;

export const getEvaluationScore = (
  evaluation: Record<string, QuestionMatchingEvaluationResponse>,
) => {
  if (evaluation) {
    const items = Object.values(evaluation);
    return (
      (items.reduce(
        (acc, val) =>
          acc +
          (val.best_match_index >= 0
            ? candidateCount - val.best_match_index
            : 0),
        0,
      ) /
        items.length) *
      candidateCount
    ).toFixed(1);
  }
  return 0;
};
